import { LINKS } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/links';
import { withFaroRouterInstrumentation } from '@grafana/faro-react';
import { createBrowserRouter } from 'react-router';
import packageJson from '../../package.json';
import AccountSettings from '../pages/AccountSettings/AccountSettings.tsx';
import ApplicationError from '../pages/ApplicationError/ApplicationError.tsx';
import Checkout from '../pages/Checkout/Checkout.tsx';
import ContactUs from '../pages/ContactUs/ContactUs.tsx';
import Dashboard from '../pages/Dashboard/Dashboard.tsx';
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword.tsx';
import FrequentlyAskedQuestions from '../pages/FrequentlyAskedQuestions/FrequentlyAskedQuestions.tsx';
import Home from '../pages/Home/Home.tsx';
import HowItWorks from '../pages/HowItWorks/HowItWorks.tsx';
import Login from '../pages/Login/Login.tsx';
import NotFound from '../pages/NotFound/NotFound.tsx';
import PaymentComplete from '../pages/PaymentComplete/PaymentComplete.tsx';
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy.tsx';
import Profile from '../pages/Profile/Profile.tsx';
import ProhibitedWords from '../pages/ProhibitedWords/ProhibitedWords.tsx';
import RegisterStripe from '../pages/RegisterStripe/RegisterStripe.tsx';
import RegisterWaitlist from '../pages/RegisterWaitlist/RegisterWaitlist.tsx';
import ResetForgotPassword from '../pages/ResetForgotPassword/ResetForgotPassword.tsx';
import ServerError from '../pages/ServerError/ServerError.tsx';
import SocialCallback from '../pages/SocialCallback/SocialCallback.tsx';
import TermsOfService from '../pages/TermsOfService/TermsOfService.tsx';
import VerifyEmail from '../pages/VerifyEmail/VerifyEmail.tsx';
import { Base } from './Base.tsx';
import RequireAuth from './RequireAuth.tsx';
import RequireNoAuth from './RequireNoAuth.tsx';

const Router = createBrowserRouter([
  {
    element: <Base />,
    errorElement: <ApplicationError />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: LINKS.LOGIN,
        element: (
          <RequireNoAuth>
            <Login />
          </RequireNoAuth>
        ),
      },
      {
        path: LINKS.REGISTER,
        element: (
          <RequireNoAuth>
            {import.meta.env.VITE_ENVIRONMENT === 'prod' ? <RegisterWaitlist /> : <RegisterWaitlist />}
          </RequireNoAuth>
        ),
      },
      {
        path: LINKS.REGISTER_COUNTRY,
        element: (
          <RequireNoAuth>
            {import.meta.env.VITE_ENVIRONMENT === 'prod' ? <RegisterWaitlist /> : <RegisterWaitlist />}
          </RequireNoAuth>
        ),
      },
      {
        path: LINKS.REGISTER_ACCOUNT,
        element: (
          <RequireNoAuth>
            {import.meta.env.VITE_ENVIRONMENT === 'prod' ? <RegisterWaitlist /> : <RegisterWaitlist />}
          </RequireNoAuth>
        ),
      },
      {
        path: LINKS.REGISTER_PROFILE,
        element: import.meta.env.VITE_ENVIRONMENT === 'prod' ? <RegisterWaitlist /> : <RegisterWaitlist />,
      },
      {
        path: LINKS.REGISTER_STRIPE,
        element:
          import.meta.env.VITE_ENVIRONMENT === 'prod' ? (
            <RequireAuth>
              <RegisterStripe />
            </RequireAuth>
          ) : (
            <RequireAuth>
              <RegisterStripe />
            </RequireAuth>
          ),
      },
      {
        path: 'confirm-email/:token',
        element: <VerifyEmail />,
      },
      {
        path: LINKS.FORGOT_PASSWORD,
        element: (
          <RequireNoAuth>
            <ForgotPassword />
          </RequireNoAuth>
        ),
      },
      {
        path: 'reset-password/:userId/:token',
        element: (
          <RequireNoAuth>
            <ResetForgotPassword />
          </RequireNoAuth>
        ),
      },
      { path: ':username', element: <Profile /> },
      {
        path: LINKS.DASHBOARD,
        element: (
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        ),
      },
      {
        path: LINKS.CHECKOUT,
        element: <Checkout />,
      },
      { path: LINKS.PAYMENT_COMPLETE, element: <PaymentComplete /> },
      {
        path: LINKS.ACCOUNT_SETTINGS,
        element: (
          <RequireAuth>
            <AccountSettings />
          </RequireAuth>
        ),
      },
      {
        path: 'x/callback',
        element: (
          <RequireAuth>
            <SocialCallback />
          </RequireAuth>
        ),
      },
      {
        path: LINKS.PROHIBITED_WORDS,
        element: <ProhibitedWords />,
      },
      {
        path: LINKS.FAQs,
        element: <FrequentlyAskedQuestions />,
      },
      {
        path: LINKS.HOW_IT_WORKS,
        element: <HowItWorks />,
      },
      {
        path: LINKS.CONTACT_US,
        element: <ContactUs />,
      },
      {
        path: LINKS.TERMS_OF_SERVICE,
        element: <TermsOfService />,
      },
      {
        path: LINKS.PRIVACY_POLICY,
        element: <PrivacyPolicy />,
      },
      {
        path: LINKS.SERVER_ERROR,
        element: <ServerError />,
      },
      {
        path: LINKS.NOT_FOUND,
        element: <NotFound />,
      },
      { path: 'version', element: packageJson.version },
    ],
  },
]);

const browserRouter = withFaroRouterInstrumentation(Router);

export default browserRouter;
